import React, { useEffect } from 'react';
import config from '@/config';
import TestimonialPageComponent from '@/src/containers/Testimonial';
import { clientGetCookie } from '@/features/authentication/utils/cookies';
import SeoConfig from '@/src/core/components/SeoConfig';

function TestimonialPage() {
  const [token, setToken] = React.useState('');

  useEffect(() => {
    const newToken = clientGetCookie('token');
    setToken(newToken);
  }, []);

  return (
    <>
      <SeoConfig
        title="Roomvu Reviews | Lead Generation Success Stories"
        description="See reviews of Roomvu for lead generation success stories. Helping Real Estate Agents, Loan Officers, Realtors, and Mortgage Brokerages to establish trust through tailored real estate websites, personalized videos, and advanced lead capturing tools. Convert real estate audience to leads with roomvu profile."
        canonical={config.websiteBaseUrl + '/testimonial'}
        image="https://dofimomuk6s4.cloudfront.net/files/th-testimonial.jpg"
      />
      <TestimonialPageComponent isAuth={!!token} />
    </>
  );
}

TestimonialPage.pageName = 'testimonial';
TestimonialPage.withIntercomChatBot = true;
export default TestimonialPage;
